/**
=========================================================
* BASE: Learning Repository - v1.0.0
=========================================================

* Copyright 2022 Sean Dooley (https://www.dooley-dev.com)

Coded by www.dooley-dev.com

 =========================================================

* The above copyright notice shall be included in substantial portions of the Software.
*/

import React from "react";
import BASELoading from "../../../../../../../@BASE/core/BASELoading";
import Box from "@mui/material/Box";
import Divider from "@mui/material/Divider";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import Paper from "@mui/material/Paper";

import EMentor from "../components/EMentor";
import Instructions from "../components/Instructions";
import ComponentCard from "../components/Component";
import ComponentPreview from "../components/Preview";
import LeftColumnDiagram from "../components/cards/leftColumn/LeftColumn";
import ComponentStepLabel from "../components/StepLabel";

import SubComponentCard from "../components/SubComponent";

const TerminologyReview = (props) => {
  const { data, dir, ins = [], course, comments = [] } = props;
  const tl = `${dir === "rtl" ? "text-18" : "text-14"} ${course?.language?.acronym}`.trim();

  if (!data) {
    return <BASELoading />;
  }

  // filer comments by component_id
  const componentCommentsCount = (component) => {
    return comments.filter(
      (comment) =>
        comment.component === component && comment.internality !== true
    ).length;
  };

  return (
    <>
      <style>{`.wysiwyg p { margin: 0px; margin-bottom: 1.5rem; }`}</style>
      <div>
        <Typography className="text-16 font-bold p-16 pb-0">
          Page Instructions:
        </Typography>

        <Instructions
          ins={ins}
          course={course}
          dir={dir}
          tl={tl}
          componentCommentsCount={componentCommentsCount}
        />

        <ComponentCard
          title="Flash Cards"
          id="flash_cards"
          commentsCount={componentCommentsCount("flash_cards")}
        >
          {data.core.map((card, index) => (
            <SubComponentCard
              key={card.term_en}
              title={"Card " + (index + 1)}
              id={card.id}
              commentsCount={componentCommentsCount(card.id)}
            >
              <Paper elevation={0} square className="p-16">
                <Grid container spacing={1}>
                  <Grid item xs={12}>
                    <Grid container spacing={1}>
                      <Grid item xs={12} sm={4} lg={2}>
                        <Typography className="text-14 font-semibold m-0">
                          Term (TL):
                        </Typography>
                      </Grid>
                      <Grid item xs={12} sm={8} lg={10}>
                        <Typography className={`${tl} m-0`} dir={dir}>
                          {card.term_tl}
                        </Typography>
                      </Grid>
                      <Grid item xs={12} sm={4} lg={2}>
                        <Typography className="text-14 font-semibold m-0">
                          Term (EN):
                        </Typography>
                      </Grid>
                      <Grid item xs={12} sm={8} lg={10}>
                        <Typography className="text-14 m-0">
                          {card.term_en}
                        </Typography>
                      </Grid>
                      <Grid item xs={12} sm={4} lg={2}>
                        <Typography className="text-14 font-semibold m-0">
                          Definition:
                        </Typography>
                      </Grid>
                      <Grid item xs={12} sm={8} lg={10}>
                        <Typography className={`${tl} m-0`} dir={dir}>
                          {card.definition}
                        </Typography>
                      </Grid>
                      <Grid item xs={12} sm={4} lg={2}>
                        <Typography className="text-14 font-semibold m-0">
                          Synonym:
                        </Typography>
                      </Grid>
                      <Grid item xs={12} sm={8} lg={10}>
                        <Typography className={`${tl} m-0`} dir={dir}>
                          {card.synonym}
                        </Typography>
                      </Grid>
                      <Grid item xs={12} sm={4} lg={2}>
                        <Typography className="text-14 font-semibold m-0">
                          Antonym:
                        </Typography>
                      </Grid>
                      <Grid item xs={12} sm={8} lg={10}>
                        <Typography className={`${tl} m-0`} dir={dir}>
                          {card.antonym}
                        </Typography>
                      </Grid>
                      <Grid item xs={12} sm={4} lg={2}>
                        <Typography className="text-14 font-semibold m-0">
                          Sentence:
                        </Typography>
                      </Grid>
                      <Grid item xs={12} sm={8} lg={10}>
                        <Typography
                          className={`${tl} wysiwyg m-0`}
                          dir={dir}
                          dangerouslySetInnerHTML={{ __html: card.sentence }}
                        />
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </Paper>
            </SubComponentCard>
          ))}
        </ComponentCard>

        {data.eMentor.length !== 0 && (
          <EMentor
            eMentor={data.eMentor}
            tl={tl}
            dir={dir}
            componentCommentsCount={componentCommentsCount}
          />
        )}
      </div>
    </>
  );
};

export default TerminologyReview;
